'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const ModalView = require('common/ui/view/modal/index');
const TaskModel = require('communication/domain/entity/task');
const TaskCreateService = require('communication/app/service/task/create');
const TaskSettingView = require('communication/ui/view/task/setting');
const TaskListView = require('communication/ui/view/task/list');
const Template = require('communication/ui/template/task/list.hbs');


module.exports = Mn.View.extend({
    template: Template,
    regions: {
        taskList: '.task-list',
    },
    ui: {
        taskCreateButton: '.task-create-button'
    },
    events: {
        'click @ui.taskCreateButton': 'createTask'
    },
    templateContext: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        const group = context.getGroup();
        return {
            isMember: group.isMember(user ? user.id : null)
        }
    },

    onRender: function() {
        this.showChildView('taskList', new TaskListView({
            collection: this.getOption('collection'),
            context: this.getOption('context'),
            PrimaryContextView: this.getOption('PrimaryContextView'),
            AdditionalView: this.getOption('AdditionalView')
        }));
    },

    createTask: function() {
        const context = this.getOption('context');
        const project = context.getProject();

        const modal = new ModalView({
            title: i18n.t('communication_template:modal.task.create-title'),
            bodyView: new TaskSettingView({
                model: new TaskModel(),
                context: this.getOption('context'),
                marked: this.getOption('marked'),
                AdditionalView: this.getOption('AdditionalView'),
                relatedKeys: this.getOption('relatedKeys'),
            }),
            onChildviewSave: function() {
                const isValid = this.getChildView('body').model.isValid(true);
                if(!isValid) {
                    return;
                }

                this.disableButtons();
                let json = this.getChildView('body').getJSON();

                const taskService = new TaskCreateService(project, json);
                taskService.create()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    }
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/related-list.js